import * as React from "react";
import styled from "styled-components";
import { COLOURS } from "../../../consts/style";
import { LiveHelp } from "../../Svg/LiveHelp";

const ContactUsContainer = styled.div`
  display: flex;
  margin-top: 8px;
  flex-direction: column;
  padding: 16px;
`;

const HelpAndSupportContainer = styled.div`
  display: flex;
  align-items: center;
  a {
    font-size: 16px;
    line-height: 28px;
    color: ${COLOURS.TEXT.HEADING};
    font-weight: 600;
    text-decoration: none;
  }
  svg {
    margin-right: 4px;
    height: 26px;
    width: 26px;
    fill: ${COLOURS.PRIMARY.ORANGE_LIGHT};
    color: ${COLOURS.PRIMARY.ORANGE_LIGHT};
  }
`;

export const MobileMenuContactUs = () => (
  <ContactUsContainer>
    <HelpAndSupportContainer>
      <LiveHelp /> <a href="/help-support">Help and support</a>
    </HelpAndSupportContainer>
  </ContactUsContainer>
);
